<template>
  <div id="container">
    <div class="header_menu">
      <ul>
        <li class="active"><a href="/">{{$t('base.home')}}</a></li>
        <li>
          <router-link :to="{path:'/market?type=auction'}">{{$t('base.auction')}}</router-link>
        </li>
        <li>
          <router-link :to="{path:'/market?type=buy'}">{{$t('base.buyNow')}}</router-link>
        </li>
        <li>
          <router-link :to="{path:'/market?type=like'}">{{$t('base.newly')}}</router-link>
        </li>
      </ul>
    </div>
    
    <!-- banner -->
    <av-swiper />
    <!-- <i18n path="alert.bargainTip" tag="p" >
      <span style="color: blue;">{{$t('alert.overseasGoodTip')}}</span>
      <span style="color: blue;">{{$t('alert.overseasGoodTip')}}</span>
    </i18n> -->
    <div class="full_layout">
      <div class="all_box">
        <div class="all_title">
          {{$t('base.shopCardHobby')}}
          <router-link :to="{path:'/list'}" target="_blank">{{$t('base.seeAll')}}</router-link>
        </div>
        <div class="banner_box">
          <!-- video -->
          <video-home class="video" />
          <!-- video -->
          <!-- <hobby-swiper class="" /> -->
          <el-skeleton :count="1" animated class="logoListBox" :loading="skeletonLoading">
            <template slot="template">
              <div class="logolist">
                <div class="skullImg el-skeleton__item el-skeleton__image logobox" v-for="(item,index) in 6" :key="index">
                  <img src='../../../static/images/LOGO_new.png' />
                </div>
              </div>
            </template>
            <template>
              <div>
                <div class="logolist">
                  <router-link class="logobox" v-for="(item,index) in SearchCategory" :key="index" :to="{path:'/list',query:{type:item.Title,index:index}}" target="_blank">
                    <img :src="item.ImgSelectedUrl">
                  </router-link>
                </div>
              </div>
            </template>
          </el-skeleton>
        </div>
      </div>
      <!-- Shop by Sports/Non-Sports/TCG -->
      <market-show />

      <template v-if="userInfo&&userInfo.MemberSource=='US'">
        <div class="buyitnow_box all_box">
          <router-link :to="{path:'/buynow'}">
            <img src="/static/images/buyitnow.jpg">
          </router-link>
        </div>
      </template>


      <!-- Recommend Sellers -->
      <recommend-swiper />
      <!-- You May Also Like -->
      <like-swiper />
    </div>
    <!-- <questionnaire :domVisible="true" ></questionnaire> -->
    <!-- 获取优惠券 -->
    <!-- <coupon class="home" type="home" :Id="shareId" :Mid="shareMid" @getDialog="getDialog" v-if="isShare" />
    <activity /> -->

    <div class="homeActivity" @click="isActivityTo" v-if="isSwitch">
      <img src="../../../static/images/Activity.png" />
      {{$t('base.Activity')}}
    </div>
  </div>
</template>
<script>
import AvSwiper from "@/components/swiper/advertisement"; //广告
import RecommendSwiper from "@/components/swiper/seller";
import LikeSwiper from "@/components/swiper/like";
import HobbySwiper from "@/components/swiper/manufacturer";
// import Coupon from "@/components/getcoupon";
import VideoHome from "@/components/video";
import MarketShow from "@/components/entry";
// import Activity from "@/components/activity/activity1"; // 新人活动

import Questionnaire from "@/components/dialog/questionnaire"; // 问卷
import { getInfo, resetStoreCategory } from "@/api/public";
export default {
  name: "index",
  components: { RecommendSwiper, LikeSwiper, HobbySwiper, AvSwiper, VideoHome, MarketShow,Questionnaire },
  data() {
    return {
      isSwitch: this.$store.state.isSwitch,
      userInfo: '',
      fid: '4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de',
      sid: '10106fda-c5d8-4121-ab21-0428534eaf42',
      shareId: '',
      shareMid: '',
      isShare: false,
      skeletonLoading: false,
      // sports: this.$enumInfo.PropertyList,
      // Logos: this.$enumInfo.facturerLogo,
      SearchCategory: this.$enumInfo.searchCategory, //新类目列表
      dislogType: this.$enumInfo.dislogType,
    };
  },
  watch: {
    '$store.state.isSwitch': {
      deep: true,
      handler(obj) {
        //console.log(obj, 'isSwitch')
        this.isSwitch = obj
      }
    }
  },
  mounted() {
  },
  created() {
    //console.log('head1')
    let id = this.$route.query.e
    let mid = this.$route.query.t
    if (id != undefined) {
      this.shareId = id
      this.shareMid = mid
      this.isShare = true
    }
    this.userInfo = getInfo();
    this.getNewCategory()
  },

  methods: {
    isActivityTo() {
      let that = this
      this.$router.push({
        name: 'Activity'
      })
      // if (that.userInfo) {
      //   this.$router.push({
      //     name: 'Activity'
      //   })
      // } else {
      //   this.$router.push({
      //     name: 'Login'
      //   })
      // }
    },
    // 获取类目（新）
    getNewCategory() {
      let that = this
      let data = { AreaCode: 'US'}
      if (that.userInfo != null) {
        data.AreaCode = that.userInfo.MemberSource
      }
      that.skeletonLoading = true
      // that.SearchCategory
      this.$get(this.$interface.GetCategoryCache, data).then(res => {
        if (res.Result) {

          if (res.Data['FristList']) {
            try{
              let NewCategory=resetStoreCategory(res.Data, ['FristList', 'SecondList', 'ThirdList'])
              
              that.SearchCategory = NewCategory.filter(item=> item.ManufacturerType==0)
            }catch(e){
              console.log(e)
            }
            that.skeletonLoading = false
          }
        }
      })
    },
    getDialog(val) {
      this.isShare = val
    }
  },
};

</script>
<style scoped>
@import "../../../static/css/home.css";


.logoListBox {
  width: 780px;
  height: 224px;
  overflow: hidden;
}

.skullImg img {
  object-fit: contain;
}

.buyitnow_box img{
  width:100%;
}

</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue